const backendDomain = "https://api.myreading.in"; 
// const backendDomain = "http://localhost:8083";
// const backendDomain = "http://localhost:8000"; // remove before deploy


const SummaryApi = {
  registerAfterPayment: { url: `${backendDomain}/api/register-after-payment`, method: "POST" },
  register: { url: `${backendDomain}/api/register`, method: "POST" },
  forgotPassword: { url: `${backendDomain}/api/forgot-password`, method: "POST" },
  resetPassword: { url: `${backendDomain}/api/reset-password`, method: "POST" },
  login: { url: `${backendDomain}/api/login`, method: "POST" },
  logout: { url: `${backendDomain}/api/logout`, method: "POST" },
  getCurrentUser: { url: `${backendDomain}/api/getCurrentUser`, method: "GET" },
  getAllUser: { url: `${backendDomain}/api/getAllUser`, method: "GET" },

  // Admin endpoints
  updateUser: (userId) => ({
    url: `${backendDomain}/api/editUser/${userId}`,
    method: "PUT"
  }),
  deleteUser: (userId) => ({
    url: `${backendDomain}/api/deleteUser/${userId}`,
    method: "DELETE"
  }),
  getUserProfile: {
    url: `${backendDomain}/api/user/profile`,
    method: "GET",
  },
  updateUserProfile: {
    url: `${backendDomain}/api/profile/update`,
    method: "PUT",
  },



  getAdminUser: { url: `${backendDomain}/api/getAdminUser`, method: "GET" },

  //subscription related 
  renewSubscription: { url: `${backendDomain}/api/renewSubscription`, method: "POST" },

  addBank: { url: `${backendDomain}/api/addBankAccount`, method: "POST" },

  updateBank: { url: `${backendDomain}/api/updateBank`, method: "PUT" },

  getBank: { url: `${backendDomain}/api/getBank`, method: "GET" },

  getTransactions: { url: `${backendDomain}/api/getTransactions`, method: "GET" },

  addMoney: { url: `${backendDomain}/api/addMoney`, method: "POST" },

  spendMoney: { url: `${backendDomain}/api/spendMoney`, method: "POST" },
  createPlan: {
    url: `${backendDomain}/api/plans/create`,
    method: "POST",
  },
  getAllPlans: {
    url: `${backendDomain}/api/plans`,
    method: "GET",
  },
  getPlanById: {
    url: (id) => `${backendDomain}/api/plans/${id}`,
    method: "GET",
  },
  updatePlan: {
    url: (id) => `${backendDomain}/api/plans/${id}`,
    method: "PUT",
  },
  deletePlan: {
    url: (id) => `${backendDomain}/api/plans/${id}`,
    method: "DELETE"
  },


  // Library Management
  createBook: { url: `${backendDomain}/api/create-book`, method: "POST" },
  getBooksBySchool: { url: `${backendDomain}/api/books`, method: "GET" },
  updateBook: (id) => ({
    url: `${backendDomain}/api/update-book/${id}`,
    method: "PUT",
  }),
  deleteBook: (id) => ({
    url: `${backendDomain}/api/delete-book/${id}`,
    method: "DELETE",
  }),
  issueBook: { url: `${backendDomain}/api/issue-book`, method: "POST" },
  returnBook: (transactionId) => ({
    url: `${backendDomain}/api/return-book/${transactionId}`,
    method: "PUT",
  }),
  getAllLibraryTransactions: {
    url: `${backendDomain}/api/transactions`,
    method: "GET",
  },

  //  Due Management
  addDueWithOptionalPayment: (id) => ({
    url: `${backendDomain}/api/add-due/${id}`,
    method: "POST",
  }),

  //Customer Related
  getCustomers: { url: `${backendDomain}/api/customers`, method: "GET" },
  createCustomer: { url: `${backendDomain}/api/customers`, method: "POST" },
  updateCustomer: (id) => ({
    url: `${backendDomain}/api/customers/${id}`,
    method: "PUT",
  }),

  deleteCustomer: (id) => ({
    url: `${backendDomain}/api/customers/${id}`,
    method: "DELETE",
  }),
  updateCustomerStatus: (id) => ({
    url: `${backendDomain}/api/customers/${id}/status`,
    method: "PATCH",
  }),
  renewMembership: (id) => ({
    url: `${backendDomain}/api/customers/${id}/renew`,
    method: "POST",
  }),
  updateMembershipPayment: (id, index) => ({
    url: `${backendDomain}/api/customers/${id}/membership/${index}`,
    method: "PATCH",
  }),
  getCustomerById: (id) => ({
    url: `${backendDomain}/api/customers/${id}`,
    method: "GET",
  }),

  //Customer Bank Related
  getCustomerBank: { url: `${backendDomain}/api/customer-banks/my`, method: "GET" },
  createCustomerBank: { url: `${backendDomain}/api/customer-banks`, method: "POST" },
  getCustomerTransactions: (bankId) => ({
    url: `${backendDomain}/api/customer-transactions/${bankId}`,
    method: "GET",
  }),

  createCustomerTransaction: {
    url: `${backendDomain}/api/transaction/create`,
    method: 'POST',
  },
  getUserTransactions: {
    url: `${backendDomain}/api/transactions/user`,
    method: 'GET',
  },
  getCustomerTransactions: (bankId) => ({
    url: `${backendDomain}/api/transactions/bank/${bankId}`,
    method: 'GET',
  }),
  getTransactionById: (id) => ({
    url: `${backendDomain}/api/transaction/${id}`,
    method: 'GET',
  }),
  deleteTransaction: (id) => ({
    url: `${backendDomain}/api/transaction/delete/${id}`,
    method: 'DELETE',
  }),

  //Razorpay
  createOrder: { url: `${backendDomain}/api/create-order`, method: "POST" },
  renewSubscription: { url: `${backendDomain}/api/renew-subscription`, method: "POST" },

};

export default SummaryApi;
